<template>
  <tr>
    <td>
      <span v-if="school.localCode" class="has-text-weight-bold">{{ school.localCode }}</span>
      <span v-else>N/A</span>
    </td>
    <td class="has-text-weight-bold" :title="school.locationName">{{ school.locationName }}</td>
    <td class="border-right">{{ school.siteCount }}</td>
    <td class="border-right nowrap">{{ school.currentBaseYear }}</td>
    <td v-bind:class="{ 'has-text-weight-bold' : !school.localCode}" class="border-right">
      {{ school.baseYearISP }}
    </td>
    <td class="border-right">{{ school.totalISP }}</td>
    <td>
      <div class="select">
        <select
          :disabled="viewOnly || !school.baseYearDecisionOptions.length"
          class="select-box-small"
          @change="updateParticipation($event.target.value, school)"
          v-model="selectedDecision">
          <option value="undefined" disabled selected hidden>Select decision</option>
          <option
            v-for="(option) in availableDecisionOptions"
            :key="option.code"
            :value="option.code">
            {{ option.description }}
          </option>
        </select>
      </div>
    </td>
    <td>{{ school.newBaseYear }}</td>
    <td>{{ school.newBaseYearTotalIdentified }}</td>
    <td class="border-right">{{ school.newBaseYearTotalEnrolled }}</td>
    <td class="border-right nowrap">{{ school.newBaseYearISP }}</td>
    <td class="border-right">
      <cep-manager-decision-status
        :status="!school.baseYearDecisionOptions.length ? 'E' : school.status"
        :variant="'outlined'"/>
    </td>
    <td>{{ school.quickTips }}</td>
  </tr>
</template>

<script>
import NotificationManager from '@/mixins/NotificationManager';
import CepManagerDecisionStatus from '@/components/CepManagerDecisionStatus.vue';

export default {
  components: {
    CepManagerDecisionStatus,
  },
  mixins: [
    NotificationManager,
  ],
  props: {
    school: {
      type: Object,
      required: true,
    },
    viewOnly: {
      type: Boolean,
    },
  },
  methods: {
    updateParticipation(value, school) {
      this.$emit('baseYearDecisionChanged', {
        value,
        school,
      });
    },
  },
  data: () => ({
    selectedDecision: '',
  }),
  created() {
    this.selectedDecision = this.school.status;
  },
  computed: {
    availableDecisionOptions() {
      if (!this.school.baseYearDecisionOptions) {
        return [];
      }

      return this.school.baseYearDecisionOptions.map((option) => {
        let description = '';
        switch (option) {
          case 'R':
            description = 'Create a New Base Year';
            break;
          case 'Y':
            description = 'Create a New Base Year';
            break;
          case 'C':
            description = 'Continue with Existing Base Year';
            break;
          case 'G':
            description = 'Grace Year';
            break;
          default:
            break;
        }
        return {
          code: option,
          description,
        };
      });
    },
  },
};
</script>

<style lang="sass" scoped>
  .border-right
    border-right: 1px solid #dee2e6
  .table tbody tr td
    padding: .1rem 0.75rem
  .select
    max-width: auto
    width: 100%
    select
      max-width: auto
      width: 100%
</style>
